export function applyUsageFormRules (schema) {
  if (!schema) {
    return schema
  }

  schema.headers = (schema.headers || []).map((header) => {
    header.options = header.options || {}
    header.options.rules = header.options.rules || []
    header.options.propbindings = header.options.propbindings || {}

    if (header.field === 'flow') {
      header.options.rules = Array.from(new Set([...(header.options.rules || []), 'required', 'positiveNumber']))
      header.options.propbindings = {
        ...header.options.propbindings,
        min: 0.01,
        hint: 'Enter the actual CFS being delivered. Usage CFS cannot be negative.',
        'persistent-hint': true
      }
    }

    if (header.field === 'off_date') {
      header.options.rules = [
        ...(header.options.rules || []),
        {
          type: 'dateOnOrAfter',
          field: 'on_date',
          message: 'Off date must be on or after the on date.'
        }
      ]
      header.options.propbindings.text = {
        ...(header.options.propbindings.text || {}),
        hint: 'Off date cannot be before the on date.',
        'persistent-hint': true
      }
    }

    if (header.field === 'off_time') {
      header.options.rules = [
        ...(header.options.rules || []),
        {
          type: 'requiredIf',
          field: 'off_date',
          message: 'Off time is required if an off date is selected.'
        }
      ]
      header.options.propbindings = {
        ...header.options.propbindings,
        hint: 'Select an off time when closing a usage.',
        'persistent-hint': true
      }
    }

    if (['on_notes', 'off_notes'].includes(header.field)) {
      header.options.propbindings = {
        ...header.options.propbindings,
        rows: 3,
        'no-resize': true
      }
    }

    return header
  })

  return schema
}

const ORDER_CONTEXT_FIELDS = ['producer', 'farmunit', 'diversionPoint']

export function applyOrderCfsCalculator (schema, active = {}, options = {}) {
  if (!schema) {
    return schema
  }

  const {
    includeCalculator = true,
    hideContextFields = false
  } = options

  schema.headers = (schema.headers || []).map((header) => {
    if (header.field === 'order_details') {
      header.options.propbindings.class = 'order-section-heading'
      header.options.propbindings.text = 'Order Details'
    }

    if (header.field === 'run_date') {
      header.options.propbindings.text = {
        ...(header.options.propbindings.text || {}),
        dense: true,
        label: 'Requested Date',
        placeholder: 'Requested Date'
      }
    }

    if (header.field === 'run_time') {
      header.options.propbindings = {
        ...(header.options.propbindings || {}),
        dense: true,
        label: 'Requested Time',
        placeholder: 'Requested Time'
      }
    }

    if (header.field === 'notes') {
      header.options.propbindings = {
        ...(header.options.propbindings || {}),
        label: 'Notes (optional)',
        rows: 2,
        'no-resize': true,
        placeholder: 'Add a note about this order...'
      }
    }

    return header
  })

  if (!active.diversionPoint) {
    schema.headers = (schema.headers || []).filter(h => !h.options?.propbindings?.isOrderDetail)
    return schema
  }

  const hasCalculator = (schema.headers || []).some(h => h.field === 'cfs_calculator')
  const filteredFields = ['order_instructions', 'flow', 'type']

  if (!includeCalculator) {
    filteredFields.push('cfs_calculator', 'order_details')
  }

  if (hideContextFields) {
    filteredFields.push(...ORDER_CONTEXT_FIELDS)
  }

  schema.headers = (schema.headers || []).filter(h => !filteredFields.includes(h.field))

  if (includeCalculator && !hasCalculator) {
    schema.headers.push({
      id: 3.2,
      order: 3.2,
      field: 'cfs_calculator',
      editable: false,
      type: 'orderCfsCalculator',
      used: {
        create: true,
        update: true
      },
      form_layout: {
        cols: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12
      },
      options: {
        propbindings: {
          isOrderDetail: true
        },
        rules: []
      },
      config: {
        icon: 'mdi-water',
        title: 'Order CFS Calculator',
        type: 'orderCfsCalculator'
      }
    })
  }

  return schema
}
